import { useNavigation } from '@waitroom/common';
import { memo, useEffect, useRef } from 'react';
import { Location, useLocation, useNavigate } from 'react-router-dom';

const AppNavigate = memo((): React.ReactElement | null => {
  const location = useLocation();
  const locationRef = useRef<Location>(location);
  locationRef.current = location;
  const navigate = useNavigate();
  const { path, params } = useNavigation.use.navigation() || {};
  const pathRef = useRef<string | undefined>(path);

  useEffect(() => {
    const { pathname, search } = locationRef.current;
    const fullPath = `${pathname}${search}`;
    if (!path || fullPath === path || path === pathRef.current) {
      return;
    }
    pathRef.current = path;
    if (path.startsWith('http')) {
      window.location.href = path;
      return;
    }
    navigate(path, {
      state: {
        from: fullPath,
        ...params,
      },
    });
  }, [navigate, path, params]);

  return null;
});

export default AppNavigate;
